export const _GLOBAL = {
	URL: {
		LOGOUT: (window as any).REACT_APP_LOGOUT_URL,
	},
};

export const DEFAULT_PAGE_INFO = {
	page: 1,
	page_size: 10,
}


export const tabColIconSucOrErrMap: any = {
  'true': 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/fuhe-icon.png',
  'false': 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/bufuhe-icon.png',
}
